import React from 'react';
import { Star } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-charcoal text-white pt-12 pb-6 mt-16 border-t-4 border-brand-yellow" data-id="element-273" data-mp="3gf958x4mo89h">
      <div className="max-w-7xl mx-auto px-4" data-id="element-274" data-mp="32nuh6bvv5gvk">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8" data-id="element-275" data-mp="32p5kybpb6omo">
          {/* Brand & Contact */}
          <div data-id="element-276" data-mp="36pzatambadi7">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.6gtools.com/uploaded/images/Redesign/6G%20Logo%20White%201.png" alt="6G Tools" className="h-10 object-contain mb-4" data-id="element-277" data-mp="36nd4tff2k623" />
            <p className="text-brand-lightGold font-semibold" data-id="element-278" data-mp="3lelzi2xtwhm3">866.212.3385</p>
          </div>

          {/* Links */}
          <div data-id="element-279" data-mp="3qcniyoz62iy3">
            <ul className="space-y-2 text-sm" data-id="element-280" data-mp="3qc40n75ltsjj">
              <li data-id="element-281" data-mp="29z6ss7ftibds">
                <a href="/about-us.html" className="text-brand-yellow hover:text-brand-lightGold transition-colors" data-id="element-282" data-mp="29yno3sf6hjhp">
                  ABOUT US
                </a>
              </li>
              <li data-id="element-283" data-mp="3labt60db0esh">
                <a href="/shipping-policy.html" className="text-brand-yellow hover:text-brand-lightGold transition-colors" data-id="element-284" data-mp="3lbmt1p3mp2eb">
                  SHIPPING POLICY
                </a>
              </li>
              <li data-id="element-285" data-mp="3q8dkf8kvvkf1">
                <a href="/return-policy.html" className="text-brand-yellow hover:text-brand-lightGold transition-colors" data-id="element-286" data-mp="3q7u0xnfl4nyw">
                  RETURN POLICY
                </a>
              </li>
              <li data-id="element-287" data-mp="3230j4ucx8yg">
                <a href="/privacy%20policy.html" className="text-brand-yellow hover:text-brand-lightGold transition-colors" data-id="element-288" data-mp="hsk0ejrcfqt8">
                  PRIVACY POLICY
                </a>
              </li>
              <li data-id="element-289" data-mp="qu1jmb01s8m5">
                <a href="/terms-and-conditions.html" className="text-brand-yellow hover:text-brand-lightGold transition-colors" data-id="element-290" data-mp="qrf67uqh6yw0">
                  TERMS & CONDITIONS
                </a>
              </li>
            </ul>
          </div>

          {/* Reviews */}
          <div data-id="element-291" data-mp="13taokhn8468t">
            <h3 className="text-lg font-bold mb-4 text-brand-yellow" data-id="element-292" data-mp="13sr4ove0j7s5">
              GOOGLE RATING
            </h3>
            <div className="bg-brand-darkGray p-4 rounded border border-gray-700" data-id="element-293" data-mp="18k98dr7f7mgt">
              <div className="flex items-center gap-1 text-brand-yellow mb-2" data-id="element-294" data-mp="1cm466lq57hpu">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-current" data-id="element-295" data-mp="1hje0aeoh8hk0" />)}
              </div>
              <p className="text-sm font-semibold mb-2" data-id="element-296" data-mp="1mkbhop1nx7kg">
                6GTOOLS RATED 4.9 / 50 REVIEWS.
              </p>
              <a href="https://g.page/r/CWKGFpgXab1yEB0/review" target="_blank" rel="noopener noreferrer" className="text-brand-yellow hover:text-brand-lightGold text-sm font-bold uppercase tracking-wider transition-colors" data-id="element-297" data-mp="1rgsfyc2kt2b9">
                | REVIEW US
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-6 text-center text-xs text-gray-500" data-id="element-298" data-mp="25maot4jdpz8l">
          <p data-id="element-299" data-mp="21n1thv8oxtax">© COPYRIGHT 2025 ALL RIGHTS RESERVED</p>
        </div>
      </div>
    </footer>;
}